import { useCarePlusPrice } from "../useCarePlusPrice";
import { Translate } from "../../ChoosePlanCarePlus/planContent";
import { CarePlusMedicationLine } from "../../ChoosePlanCarePlus/useChoosePlanCarePlus";
import OptionRadio from "./OptionRadio";
import { hasOneTimeDiscount } from "../pricing";
import checkIcon from "../../../icons/care_plus_one_time_check.svg";

// the one-time card. Priced by the page: medication + all three fees, struck
// through over what the one-time bonus leaves.
interface Props {
  t: Translate;
  medication: CarePlusMedicationLine | null;
  price: number;
  chargedPrice: number;
  isSelected: boolean;
  onSelect: () => void;
}

const OneTimeOrderCard = ({ t, medication, price, chargedPrice, isSelected, onSelect }: Props) => {
  const { formatPrice } = useCarePlusPrice();
  const hasDiscount = hasOneTimeDiscount(price, chargedPrice);
  const medicationPrice = medication?.official_price ?? medication?.item_price ?? 0;

  return (
    <div
      id="wl3_plan_one_time"
      data-testid="care-plus-one-time-option"
      onClick={onSelect}
      className={`flex w-full cursor-pointer items-center gap-[10px] rounded-[16px] border-2 border-solid bg-white py-[12px] pl-[12px] pr-[14px] ${
        isSelected ? "border-[#f59603]" : "border-[#dee3ed]"
      }`}
    >
      <OptionRadio selected={isSelected} />
      <div className="flex min-w-0 flex-1 flex-col gap-[2px]">
        <p className="text-[14px] font-medium leading-normal text-[#08080a]">{t("tier_one_time_order", "One Time order")}</p>
        <p className="text-[12px] leading-normal text-[#8a9099]">
          {t("desc_one_time_order", "Prescription + medication + delivery, single purchase")}
        </p>
        {medication && (
          <div data-testid="care-plus-one-time-medication" className="flex w-full min-w-0 items-center gap-[4px]">
            <img src={checkIcon} alt="" className="block shrink-0" />
            <span className="min-w-0 flex-1 text-[12px] leading-[17.551px] text-[#08080a]">
              {[medication.title, medication.quantityStr, formatPrice(medicationPrice)].filter(Boolean).join(" ")}
            </span>
          </div>
        )}
      </div>
      {price > 0 && (
        <div className="flex shrink-0 flex-col items-end gap-[4px] self-stretch">
          {hasDiscount && (
            <span
              data-testid="care-plus-one-time-original-fee"
              className="bg-[#ebf0f7] text-[10px] font-medium leading-normal text-[#616975] line-through"
            >
              {formatPrice(price)}
            </span>
          )}
          <span
            data-testid="care-plus-one-time-charged-fee"
            className={`text-[15px] font-semibold leading-normal ${hasDiscount ? "text-[#61a333]" : "text-[#08080a]"}`}
          >
            {formatPrice(chargedPrice)}
          </span>
        </div>
      )}
    </div>
  );
};

export default OneTimeOrderCard;
